module.exports = __webpack_public_path__ + "static/media/faceFrame.73644615.svg";